<template>
    <div id="app">
        <div class="container">
            <div class="jumbotron" ref="jumbotron">
                <div class="accounts" ref="accounts" :class="{'onlyavatars': onlyAvatars}"
                     v-if="$api.getUser().user !== null && $api.getUser().user !== undefined">
                    <div class="account" v-for="a in $api.getUser().user.accounts"
                         :class="{'active': $api.getUser().user.uuid === a.uuid}" @click="goToOwnUser(a)">
                        <img :src="'https://minotar.net/helm/'+a.uuid+'/25.png'"/> <span>{{a.username}}</span>
                    </div>
                </div>
                <nav>
                    <div class="row">
                        <div class="left">
                            <div class="brand">
                                <router-link to="/"><img src="./assets/logo.png"></router-link>
                            </div>
                            <div class="menu">
                                <div class="top">
                                    <span class="punishment-type"
                                          :class="{'active': (this.$route.path.includes('ban') || this.$route.path.includes('mute')||this.$route.path.includes('kick')||this.$route.path.includes('name')) && !this.$route.path.includes('discord')}"
                                          v-if="$api.getUser().hasPermission(['bansite.view.*', 'bansite.view.discord'])">
                                        MINECRAFT
                                    </span>
                                    <router-link :to="{name: 'mc_bans', params: {page: 1}}"
                                                 :class="{'active': this.$route.path.includes('ban') && !this.$route.path.includes('discord')}">
                                        BANS
                                    </router-link>
                                    <span class="text-muted"> / </span>
                                    <router-link :to="{name: 'mc_mutes', params: {page: 1}}"
                                                 :class="{'active': this.$route.path.includes('mute') && !this.$route.path.includes('voicemute') && !this.$route.path.includes('discord')}">
                                        MUTES
                                    </router-link>
									<span class="text-muted"> / </span>
									<router-link :to="{name: 'mc_kicks', params: {page: 1}}"
												 :class="{'active': this.$route.path.includes('kick') && !this.$route.path.includes('discord')}">
										KICKS
									</router-link>
									<span class="text-muted"> / </span>
									<router-link :to="{name: 'mc_voicemutes', params: {page: 1}}"
												 :class="{'active': this.$route.path.includes('voicemute') && !this.$route.path.includes('discord')}">
										VOICE-MUTES
									</router-link>
                                    <span class="text-muted"
                                          v-if="$api.getUser().hasPermission(['bansite.view.*', 'bansite.view.nameban'])"> / </span>
                                    <router-link :to="{name: 'mc_names', params: {page: 1}}"
                                                 v-if="$api.getUser().hasPermission(['bansite.view.*','bansite.view.nameban'])"
                                                 :class="{'active': this.$route.path.includes('name') && !this.$route.path.includes('discord')}">
                                        NAMEBANS
                                    </router-link>
                                </div>
                                <div class="bottom"
                                     v-if="$api.getUser().hasPermission(['bansite.view.*', 'bansite.view.discord'])">
                                    <span class="punishment-type"
                                          :class="{'active': (this.$route.path.includes('ban') || this.$route.path.includes('mute')||this.$route.path.includes('kick')||this.$route.path.includes('name')) && this.$route.path.includes('discord')}">
                                        DISCORD
                                    </span>
                                    <router-link to="/discord/bans/1"
                                                 :class="{'active': this.$route.path.includes('discord/ban')}">
                                        BANS
                                    </router-link>
                                    <span class="text-muted"> / </span>
                                    <router-link to="/discord/mutes/1"
                                                 :class="{'active': this.$route.path.includes('discord/mute')}">
                                        MUTES
                                    </router-link>
                                    <span class="text-muted"> / </span>
                                    <router-link to="/discord/kicks/1"
                                                 :class="{'active': this.$route.path.includes('discord/kick')}">
                                        KICKS
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <Search/>
                        </div>
                    </div>
                </nav>
                <main>
                    <router-view :key='$route.fullPath'></router-view>
                </main>
            </div>
            <footer>
                <a v-if="$api.getUser().user === null" :href="loginUrl">log in</a>
                <a v-else href="#" @click="logout()">log ud</a>
            </footer>
        </div>
    </div>
</template>

<script>
    import Search from './components/Search'

    export default {
        components: {
            Search
        },
        data() {
            return {
                onlyAvatars: false,
                avatarWidth: -1
            }
        },
        computed: {
            loginUrl() {
                return this.$api.getUri() + "api/auth/"
            },
        },
        methods: {
            logout() {
                let token = localStorage.getItem("auth_token");
                localStorage.removeItem("auth_token");
                window.location.href = this.$api.getUri() + "api/auth/logout?token=" + token;
            },
            checkOnlyAvatars() {
                if (this.$refs.accounts === undefined) {
                    this.onlyAvatars = false;
                }
                // this.onlyAvatars = this.$refs.accounts.clientWidth > this.$refs.jumbotron.clientWidth
                if (this.avatarWidth === -1) {
                    this.avatarWidth = this.$refs.accounts.clientWidth;
                }
                this.onlyAvatars = this.avatarWidth > this.$refs.jumbotron.clientWidth
            },
            goToOwnUser(selected) {
                if (this.$api.getUser().user.username === selected.username) {
                    this.$router.push({name: 'mc_user', params: {username: selected.username, page: 1}})
                } else {
                    this.$api.setSelectedUser(selected.uuid)
                }
            }
        },
        mounted() {
            let token = this.$route.query.token;
            if (token !== null && token !== undefined) {
                localStorage.setItem("auth_token", this.$utils.getParameterByName('token', window.location.href));
                this.$router.replace('/')
            }
            this.$api.updateUser();
            setTimeout(() => {
                this.checkOnlyAvatars();
            }, 1000);
            window.addEventListener('resize', this.checkOnlyAvatars)

            if (this.$route.query.twofa) {
                this.$swal({
                    title: 'Adgang Nægtet',
                    text: 'Du har adgang til staff indstillinger på denne side, det er derfor påkrævet, at du har totrinsbekræftelse slået til på din Discord konto!',
                    icon: 'error'
                }).then(r => {
                    this.$router.replace('/')
                });
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkOnlyAvatars)
        }
    }
</script>

<style lang="scss">
    @import "styles/reset";

    body {
        background-color: #33333a;
        color: #fff;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif;
    }

    .container {
        padding-top: 3rem;
        margin: 0 auto;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        max-width: 1340px;

    }

    .jumbotron {
        background: #36393f;
        box-shadow: 0 0 50px rgba(0, 0, 0, .3);
        border-radius: 0;
        padding: 3rem 2rem 2rem;
        margin-bottom: 2rem;
        position: relative;

        .accounts {
            box-shadow: 0 0 50px rgba(0, 0, 0, .3);
            position: absolute;
            top: -41px;
            left: 0;
            display: flex;

            .account {
                padding: 8px 12px;
                display: flex;
                align-items: center;
                background: darken(#36393f, 5);
                color: darken(#fff, 50);
                border-right: 1px solid darken(#36393f, 10);
                cursor: pointer;

                &:first-child {
                    margin-left: -1px;
                    border-left: 1px solid darken(#36393f, 10);
                }


                img {
                    margin-right: 5px;
                    border-radius: 50%;
                    opacity: .6;
                }

                &:after {
                    background: #36393f;
                    height: 50px;
                    content: "";
                    position: absolute;
                    bottom: -50px;
                    left: 0px;
                    right: 0px;
                }

                &:last-child:after {
                    right: -40px;
                }

                &.active {
                    background: #36393f;
                    color: #fff;

                    img {
                        opacity: 1;
                    }
                }
            }

            &.onlyavatars {
                .account {
                    transition: ease .2s;

                    span {
                        display: none;
                    }

                    img {
                        margin-right: 0;
                    }

                    &:hover {
                        img {
                            margin-right: 5px;
                        }

                        span {
                            display: inline;
                        }
                    }

                    &.active {
                        img {
                            margin-right: 5px;
                        }

                        span {
                            display: inline;
                        }
                    }
                }
            }
        }
    }

    nav {
        padding: 0 20px;
        font-size: 20px;

        .row {
            display: flex;
            justify-content: space-between;

            .left {
                display: flex;
                align-items: center;
            }
        }


        .menu {
            line-height: 100%;
            padding-left: 30px;

            a {
                color: #6c757d;
                text-decoration: none;

                &.active {
                    color: #fff;
                    font-weight: 700;
                }
            }

            span {
                color: #6c757d;

                &.active {
                    color: #fff;
                    font-weight: 700;
                }
            }
        }

        .brand {
            img {
                max-height: 100px;
                vertical-align: middle;
            }
        }
    }

    footer {
        padding-bottom: 1rem;
        display: flex;
        justify-content: flex-end;

        a {
            text-align: right;
            color: #f44336;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    main {
        padding-top: 40px;
    }

    @media screen and (max-width: 1400px) {
        .container {
            max-width: 960px;
        }
        nav {
            .punishment-type {
                display: block;
            }

            .bottom .punishment-type {
                margin-top: 5px;
            }
        }
    }

    @media screen and (max-width: 990px) {
        .container {
            max-width: 720px;
            padding-top: 0;
        }
        .accounts {
            display: none !important;
        }
        nav .row, nav .row .left {
            display: block;
            text-align: center;
        }
        nav .row .right {
            display: flex;
            justify-content: center;
        }
        nav .menu {
            padding-left: 0;
        }
        .brand {
            display: block;
            margin-bottom: 15px;
        }
    }

    @media screen and (max-width: 760px) {
        .container {
            max-width: 540px;
        }
    }

    @media screen and (max-width: 585px) {
        .container {
            padding: 0;
        }
        footer {
            justify-content: center;
        }
        .jumbotron {
            padding: 3rem 0rem 2rem;
        }
    }


</style>
